export const black = '#111'
export const white = '#EEE'
export const red = '#9e1010'

export const grayscaleWithAlpha = (white: number, alpha: number) =>
  `rgba(${255 * white}, ${255 * white}, ${255 * white}, ${alpha})`
export const redWithAlpha = (alpha: number) => `rgba(158, 16, 16, ${alpha})`
